import { render, staticRenderFns } from "./AdminAllowedIPs.vue?vue&type=template&id=31d4fa9a&scoped=true"
import script from "./AdminAllowedIPs.vue?vue&type=script&lang=js"
export * from "./AdminAllowedIPs.vue?vue&type=script&lang=js"
import style0 from "./AdminAllowedIPs.vue?vue&type=style&index=0&id=31d4fa9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d4fa9a",
  null
  
)

export default component.exports